import About from "./About";
import Skills from "./Skills";
import Experience from "./Experience";
import Projects from "./Projects";
import Publications from "./Publications";
import Education from "./Education";
import Achievements from "./Achievements";
import Footer from "./Footer";
import Contact from "./Contact";
import Journey from "./Journey";

const Main = () => (
  <main id="main">
    <About />
    <Journey />
    <Experience />
    <Projects />
    <Publications />
    <Skills />
    <Achievements />
    <Education />
    <Contact />
    <hr />
    <Footer />
  </main>
);

export default Main;
